import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { Box } from "@mui/system"
import { useTranslation } from "react-i18next"

const StyledBox = styled(Box)(({ bgColor }) => ({
  marginLeft: "30px",
  marginRight: "30px",
  padding: "16px",
  borderRadius: "5px",
  backgroundColor: bgColor
}))

const WorkOrderCardDetails = ({ values, bgColor }) => {
  const { t } = useTranslation()
  return (
    <StyledBox bgColor={bgColor} p={2} mt={4}>
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
        <Box p={2}>
          <Typography>{t("issuereports.reg_no", "Reg no")}</Typography>
          <Typography variant="h6">{values.regNumber}</Typography>
        </Box>
        <Box p={2}>
          <Typography>{t("global.chassis_number", "Chassis number")}</Typography>
          <Typography variant="h6">{values.chassiNumber}</Typography>
        </Box>
        <Box p={2}>
          <Typography>{t("global.year_model", "Year model")}</Typography>
          <Typography variant="h6">{values.vehicleYear}</Typography>
        </Box>
        <Box p={2}>
          <Typography>{t("global.model", "Model")}</Typography>
          <Typography variant="h6">{values.model}</Typography>
        </Box>
        <Box p={2}>
          <Typography>{t("global.manufacturer", "Manufacturer")}</Typography>
          <Typography variant="h6">{values.model?.split(" ")[0]}</Typography>
        </Box>
      </Box>
    </StyledBox>
  )
}

export default WorkOrderCardDetails
